(() => {
  if (window.rednibGuaranteeReady) return;
  window.rednibGuaranteeReady = true;
  let opener;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-rednib-guarantee]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById('rednib-legal-guarantee');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    opener = link;
    dialog.removeAttribute('data-zoomed');
    const zoom = dialog.querySelector('[data-rednib-guarantee-zoom]');
    zoom.setAttribute('aria-pressed', 'false');
    zoom.textContent = zoom.dataset.zoomLabel;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('rednib-guarantee-open');
    const panel = dialog.querySelector('.rednib-guarantee-scroll');
    panel.scrollTop = 0;
    panel.scrollLeft = 0;
  });
  document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('rednib-legal-guarantee');
    if (!dialog) return;
    const zoom = dialog.querySelector('[data-rednib-guarantee-zoom]');
    zoom.addEventListener('click', () => {
      const expanded = dialog.toggleAttribute('data-zoomed');
      zoom.setAttribute('aria-pressed', String(expanded));
      zoom.textContent = expanded ? zoom.dataset.fitLabel : zoom.dataset.zoomLabel;
      dialog.querySelector('.rednib-guarantee-image-pan').scrollLeft = 0;
    });
    dialog.querySelector('.rednib-guarantee-controls a').addEventListener('click', (event) => {
      event.preventDefault();
      const text = dialog.querySelector('#rednib-guarantee-transcript');
      text.scrollIntoView({ block: 'start' });
      text.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-rednib-guarantee-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('rednib-guarantee-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  });
})();
